import { useForm } from 'react-hook-form'
import { Button } from '@cocoonspace/ui/components/button'
import { Form } from '@cocoonspace/ui/components/form'
import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { Input } from '@cocoonspace/ui/components/input'
import { zodResolver } from '@hookform/resolvers/zod'
import { Trans, useLingui } from '@lingui/react/macro'
import { sendPasswordResetEmail } from 'firebase/auth'
import { toast } from 'sonner'
import * as z from 'zod'

import { useHttpErrorMsg } from '~/lib/get-http-error-msg'
import { getAuthInstance, useAuth } from '~/providers/auth-provider'

type FormData = z.infer<typeof forgottenPassSchema>

const forgottenPassSchema = z.object({
	email: z.email().min(1),
})

export const ForgottenPassForm = () => {
	const { t } = useLingui()
	const httpErrorMsg = useHttpErrorMsg()
	const { setAuthDialogActiveTab } = useAuth()

	const form = useForm<FormData>({
		resolver: zodResolver(forgottenPassSchema),
		values: {
			email: '',
		},
	})

	const onSubmitForm = (data: FormData) => {
		const auth = getAuthInstance()

		return sendPasswordResetEmail(auth, data.email)
			.then(() => {
				toast.success(
					<Trans>
						Vous allez recevoir un email à cette adresse :{' '}
						<strong>{data.email}</strong>
					</Trans>,
				)
			})
			.catch((error: any) => {
				toast.error(httpErrorMsg[error.code]?.() || t`Une erreur est survenue`)
			})
	}

	return (
		<>
			<p>
				<Trans>
					Renseignez l'email <strong>utilisé lors de votre inscription</strong>{' '}
					pour pouvoir en créer un nouveau :
				</Trans>
			</p>

			<div className='flex flex-col gap-6'>
				<form
					className='flex flex-col gap-4'
					onSubmit={form.handleSubmit(onSubmitForm)}
					noValidate
				>
					<Form {...form}>
						<FormControlledInput
							control={form.control}
							label={t`Email`}
							name='email'
							required
							render={({ field }) => (
								<Input
									{...field}
									type='email'
									required
								/>
							)}
						/>

						<Button
							type='submit'
							className='w-full'
						>
							{t`Réinitialisation du mot de passe`}
						</Button>
					</Form>
				</form>

				<button
					className='text-primary'
					onClick={() => setAuthDialogActiveTab('login')}
					type='button'
				>
					{t`Se connecter`}
				</button>
			</div>
		</>
	)
}
